export type FuncValue<TValue> = (() => TValue) | TValue;
export function evaluate<TValue>(value: FuncValue<TValue>): TValue {
    return isFunction(value) ? value() : value;
}
export function isFunction(val: any): val is Function {
    return typeof val === "function";
}

export interface INumberSelection {
    id: number;
    onChange: (id: number) => void;
}

export interface IStringSingleSelection {
    id: string;
    onChange: (id: string) => void;
}

export interface IStringMultipleSelection {
    ids: { [id: string]: string };
    onChange: (id: string) => void;
}

export interface IMultipleSelection<T> {
    ids: Map<string, boolean>;
    onChange: (id: T) => void;
}

export interface IExpanding {
    value: boolean;
    onToggle: () => void;
}

export interface IComponentProps {
    key?: string | number;
    id?: string;
    ref?: React.Ref<any>;
    children?: React.ReactNode;
    className?: string;
}

export enum ColorType {
    Default,
    Primary,
    Secondary,
    Success,
    Warning,
    Danger,
    Info,
    Link
}

// TODO: other possible way instead enums
// export type Color = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'link';
export const colorMapping = {
    [ColorType.Default]: 'default',
    [ColorType.Primary]: 'primary',
    [ColorType.Secondary]: 'secondary',
    [ColorType.Success]: 'success',
    [ColorType.Warning]: 'warning',
    [ColorType.Danger]: 'danger',
    [ColorType.Info]: 'info',
    [ColorType.Link]: 'link',
};